import OrganisationApi from '@packages/organisations/api';

export class FundManagerApi extends OrganisationApi {
    static resource = 'fund-managers';
}

export default FundManagerApi;
